import React, { useEffect, useState } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import "../../css/Admin-Volunteering/AdminVolunteeringCard.css";
import AdminEditVolunteering from "./AdminEditVolunteering";
import { toast } from "react-toastify";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const AdminVolunteeringCard = ({ data, fetchData,projectKey }) => {
  const [editProject, setEditProject] = useState(false);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this Volunteering?")) {
      try {
        await deleteDoc(doc(db, "volunteering", projectKey));
        toast.success("Volunteering deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete Volunteering");
      }
    }
  };


  return (
    <div className="product-container">
      <div className="product-card">
        <div className="product-image-div">
          <img
            src={data.volunteeringCertificates}
            alt={data.volunteeringCertificates}
            className="product-image"
          />
        </div>
        <h1 className="product-name">{data.volunteeringInstitute}</h1>
        <p className="product-description">{data.volunteeringName}</p>
        <div className="product-buttons">
          

          <div className="edit-button" onClick={() => setEditProject(true)}>
            <MdModeEditOutline style={{fontSize:'1.5rem' }}/>
          </div>

          <div className="delete-button" onClick={handleDelete}>
            <MdDelete style={{ fontSize: "1.5rem" ,color:"white"}} />
          </div>

        </div>
      </div>

      {editProject && (
                <AdminEditVolunteering onClose={() => setEditProject(false)} productData={data} fetchData={fetchData} projectKey={projectKey}/>
            )}
    </div>
  );
};

export default AdminVolunteeringCard;
